import { Button, Col, Form, Row, Select } from "antd";
import ConfigureTextingCampaignModal from "features/bulkActions/components/configureTextingCampaignModal";
import { useState } from "react";
import styled from "styled-components";

const StyledSelect = styled(Select)`
  max-width: 400px !important;
  margin-right: 4px;
`;

export default function SendTextSubForm({ setHideParentModal, operationType, initialProvider }) {
  const form = Form.useFormInstance();
  const [textOptionsModalOpen, setTextOptionsModalOpen] = useState(false);

  const filterOption = (inputValue, option) => {
    const fullOptionText = option.label;
    return fullOptionText?.toLowerCase().includes(inputValue?.toLowerCase());
  };

  const onConfigureTextCampaignClick = () => {
    const provider = form.getFieldValue(["operations", "sendText", "provider"]);
    if (provider) {
      setTextOptionsModalOpen(true);
      setHideParentModal(true);
    }
  };

  return (
    <>
      <Row align="middle" gutter={12}>
        <Col span={12}>
          <Form.Item
            name={["operations", "sendText", "provider"]}
            label="Provider"
            initialValue={initialProvider}
            rules={[
              {
                required: true,
                message: "Please select a provider",
              },
            ]}
          >
            <StyledSelect
              showSearch
              filterOption={filterOption}
              popupMatchSelectWidth={false}
              options={[
                {
                  label: "Solutions By Text",
                  value: "solutions_by_text",
                },
                {
                  label: "TCN",
                  value: "tcn",
                },
              ]}
              placeholder="Select one..."
              allowClear
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item hidden name={["operations", "sendText", "phoneConfigs"]} />
          <Form.Item hidden name={["operations", "sendText", "communicationMethodId"]} />
          <Form.Item
            noStyle
            shouldUpdate={(prev, curr) =>
              prev?.operations?.sendText?.provider !== curr?.operations?.sendText?.provider
            }
          >
            {({ getFieldValue }) => {
              const provider = getFieldValue(["operations", "sendText", "provider"]);
              const options = getFieldValue(["operations", "sendText", "communicationMethodId"]);
              if (!provider) {
                return null;
              }
              if (!options) {
                return (
                  <Button type="link" onClick={onConfigureTextCampaignClick}>
                    Configure provider
                  </Button>
                );
              }
              return (
                <Button type="link" onClick={onConfigureTextCampaignClick}>
                  Re-configure provider
                </Button>
              );
            }}
          </Form.Item>
        </Col>
      </Row>
      <ConfigureTextingCampaignModal
        operationType={operationType}
        provider={form.getFieldValue(["operations", "sendText", "provider"])}
        open={textOptionsModalOpen}
        onCancel={() => {
          setTextOptionsModalOpen(false);
          setHideParentModal(false);
        }}
        onSubmit={(data) => {
          form.setFieldValue(["operations", "sendText", "communicationMethodId"], data.template);
          setTextOptionsModalOpen(false);
          setHideParentModal(false);
        }}
        title="Configure Texting Campaign"
      />
    </>
  );
}
